import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step11 } from '../../../../shared/models/component-messages/mapaIN/step11';
import { RadioCheckBoxEnum } from '../../../common/radio.checkbox.enums';
import { DocPayants } from '../models/DocPayants';
@Component({
  selector: 'app-doc-payants',
  templateUrl: './doc-payants.component.html'
})
export class DocPayantsComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'DocPayants';
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	
	@Input() docPayants: DocPayants;

  public step11 = new Step11();

  radioButtonValue;
	radioButtonCtrlName;
	non = RadioCheckBoxEnum.nonValue;
	oui = RadioCheckBoxEnum.ouiValue;

	constructor() { }

	public ngOnInit() {
		if (this.docPayants?.non === RadioCheckBoxEnum.emptyValue) {
			this.radioButtonValue = this.non;
		}
		else {
			this.radioButtonValue = this.oui;
		}

		this.radioButtonCtrlName = this.getUid() + '_SepAtt_non';
	}

	getIsOui(){
		return this.parentForm.controls[this.radioButtonCtrlName].value === this.oui;
	}
  
  
  
  
  

  
  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }
  
  
}

